export enum TestTypes {
  Test = 'test',
  Profile = 'profile',
  Panel = 'panel'
}
